import { useState, useMemo, useEffect } from "react";
import { menus as allMenus } from "config/menus";
import { getRoles } from "services/sessionService";

interface Menu {
  id: number;
  name: string;
  path?: string;
  icon: JSX.Element;
  roles: string[];
}

export default function useConfig() {
  const [loading, setLoading] = useState(true);
  const [menu, setMenu] = useState<any>([]);
  
  useEffect(() => {
    const getMenuByRole = (perfil: string) => {
      return new Promise(resolve => {
        const allowedMenus: any[] = [];
        allMenus.map((menu: Menu) => menu.roles.includes(perfil) && allowedMenus.push(menu));
        resolve(allowedMenus);
      })
    }

    const resolveMenu = async () => {
      const roles = await getRoles().then(res => res.data.PERFIL);
      const menu = await getMenuByRole(roles);
      return menu;
    }

    resolveMenu().then(menu => {
      setMenu(menu);
      setLoading(false);
    });
  }, [])

  const menus = menu;
  return useMemo(() => {
    return {
      menus, loading
    };
  }, [menus, loading]);
}

